import { Injectable } from '@angular/core';
import { ToastrManager } from 'ng6-toastr-notifications';


@Injectable()
export class UtilityService{
    constructor(public toastr: ToastrManager) { }
	    
		 public showSuccess(message: any,position: any = 'top-center', animate: any = 'slideFromTop', toastTimeout:any = '3000' ) {
			this.toastr.customToastr('<div style="padding:20px;background-color:green"><i style="margin-right:5px" class="fa fa-check"></i> '+message+' </div>', null,{
							position: position,
				animate: animate,
				toastTimeout: toastTimeout,
				enableHTML: true
					});
		}
	
		public showError(message: any,position: any = 'top-center', animate: any = 'slideFromTop', toastTimeout:any = '3000') {
			this.toastr.customToastr('<div style="padding:20px;background-color:red"><i style="margin-right:5px" class="fa fa-close"></i> '+message+' </div>', null,{
				position: position,
				animate: animate,
				toastTimeout: toastTimeout,
				enableHTML: true
			});
		}
}
